import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-main-company-badge',
    templateUrl: './main-company-badge.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class MainCompanyBadgeComponent {

    constructor() {
    }

}
